import {Directive, Input} from '@angular/core';

@Directive({
    selector: '[imageThumbnailUpdate]',
    host: {
      '(error)':'updateImageThumbnail()'
    },
    standalone: false
})
 export class ImageThumbnailUpdate {

    @Input() imageObject: { model: { url: string } };

    updateImageThumbnail() {
      if(this.imageObject?.model?.url){
        this.imageObject.model.url = '';
      }
    }
  }